<div class="tooling-container">
  <div class="total-number">
    {{ 'VALUE Toolings' | translate: { value: toolingService.state.total } }}
  </div>

  <rotec-default-grid-v2
    [darkMode]="true"
    [filterButton]="false"
    [searchInput]="true"
    [selectConfig]="{ checkboxAlwaysVisible: true, checkboxToggleOnWholeRow: true }"
    [columns]="toolingService.columns"
    [data]="toolingService.state$ | async"
    [selectedResults]="toolingService.selectedIds$ | async"
    (stateChange)="toolingService.search($event)"
    (fulltextSearchChanged)="search($event, 'tooling')"
    (selectedResultsChange)="selectedResultsChange('tooling', $event)"
  >
    <ng-template rotecGridCellV2="name" let-dataItem="dataItem">
      <p class="grid-text-cell">{{ dataItem.name }}</p>
    </ng-template>
    <ng-template rotecGridCellV2="inventoryNumber" let-dataItem="dataItem">
      <p class="grid-text-cell">{{ dataItem.inventoryNumber }}</p>
    </ng-template>
    <ng-template rotecGridCellV2="machines" let-dataItem="dataItem">
      <p class="grid-text-cell">{{ dataItem.machines }}</p>
    </ng-template>
    <ng-template rotecGridCellV2="toolingForRotor" let-dataItem="dataItem">
      <p class="grid-text-cell">{{ dataItem.toolingForRotor }}</p>
    </ng-template></rotec-default-grid-v2
  >
</div>
